<!-- <h1 mat-dialog-title>Rapporter {{data.user}}</h1> -->
<h1 mat-dialog-title>Rapporter </h1>
<div mat-dialog-content>
  <p>C'est quoi le problem ?</p>
  <mat-form-field>
    <mat-label>problem</mat-label>
    <input matInput>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button  class="btn btn-primary"  mat-button [mat-dialog-close]="data.animal" (click)="test()" cdkFocusInitial>Rapporter</button>
</div>
